import { STATUS_NAME } from '@constants/status';

export const ALLOWED_SUBMISSION_LIST = [STATUS_NAME.READY_FILE, STATUS_NAME.SENT_FOR_FILING];
